export const MEDICATIONS_ERROR_STATE_PREFIX = 'medicationRow';
